export enum PinnedItemType {
  USER = "USER",
  DATABASE = "DATABASE",
  ENGINE = "ENGINE",
  SCRIPT = "SCRIPT",
  ROLE = "ROLE",
  TABLE = "TABLE",
  VIEW = "VIEW",
}
